module.exports = __webpack_public_path__ + "media/newstyle/images/itau-3f886df93679b78066d2d7ca1cecddf5.svg";